<!-- ################# SITE ################## -->

<!-- Global site tag (gtag.js) - Google Analytics -->
    <script async src="https://www.googletagmanager.com/gtag/js?id=UA-197991674-2"></script>
    <script>
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'UA-197991674-2');
    </script>

<!-- bootstrap core css -->

<style src="../../assets/site/css/font-awesome.min.css"></style>
<style src="../../assets/site/css/themify-icons.css"></style>
<style src="../../assets/site/css/magnific-popup.css"></style>
<style src="../../assets/site/css/owl.theme.default.min.css"></style>
<style src="../../assets/site/css/owl.carousel.min.css"></style>
<style src="../../assets/site/css/bootstrap.min.css"></style>
<style src="../../assets/site/css/style.css"></style>
<style src="../../assets/site/css/responsive.css"></style>
<script src="../../assets/site/js/vendor/modernizr-2.8.1.min.js"></script>


    <!-- HTML5 Shim and Respond.js for IE8 support of HTML5 elements and media queries -->
    <!-- WARNING: Respond.js doesn't work if you view the page via file:// -->
    <!--[if lt IE 9]>
    <script src="js/vendor/html5shim.js"></script>
    <script src="js/vendor/respond.min.js"></script>
    <![endif]-->
<!-- ################# SITE ################## -->


    

<template>
<div id="main" class="main-content-wraper">
    <div class="main-content-inner">

        <!--start header section-->
        <header class="header">
            <!--start navbar-->
            <div class="navbar navbar-default navbar-fixed-top">
                <div class="container">
                    <div class="row">
                        <div class="navbar-header page-scroll">
                            <button type="button" class="navbar-toggle collapsed" data-toggle="collapse"
                                    data-target="#myNavbar">
                                <span class="sr-only">Toggle navigation</span>
                                <span class="icon-bar"></span>
                                <span class="icon-bar"></span>
                                <span class="icon-bar"></span>
                            </button>
                        </div>

                        <!-- Collect the nav links, forms, and other content for toggling -->
                        <div class="navbar-collapse collapse" id="myNavbar">
                            <ul class="nav navbar-nav navbar-right">
                                <li><a href="/">Home</a></li>
                                <li><a href="#">Blog</a></li>
                                
                            </ul>
                        </div>

                    </div>
                </div>
            </div>
            <!--end navbar-->
        </header>
        <!--end header section-->

        <!--start breadcrumb section-->
        <section class="breadcrumb-section" style="background: url('img/download-bg.jpg')no-repeat center center fixed">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="text-center breadcrumb-content">
                            
                            <h2>Dicas de práticas sustentáveis em creches e escolas</h2>
                            <p>Dicas super simples que todas escolas podem aplicar.</p>

                            <!-- <ul class="breadcrumb">
                                <li><a href="/">Home</a></li>
                                <li>Dicas de práticas sustentáveis em creches e escolas</li>
                            </ul> -->
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--end breadcrumb section-->

        <!--start blog single section-->
        <section class="blog-details-area bg-secondary ptb-60">
            <div class="blog-details-area-wrap">
                <div class="container">
                    <div class="row">
                        <div class="col-md-8 col-md-offset-2">
                            <div class="blog-single-content-wrap">
                                <div class="blog-single-img">
                                    <a style="cursor:pointer" @click="goToInclass"><img src="https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/banners%2Fbanner-fb01.jpg?alt=media" style="width:100%; height:auto"></a>
                                    
                                </div>
                                <h1>Dicas de práticas sustentáveis em creches e escolas</h1>
                                <div class="blog-details-post-meta">Postado <span>29 de janeiro de 2019</span> by InClass</div>
                                <div class="blog-details-text">

                                    <h4>Coletores seletivos</h4>                                    
                                    <p>O que sua escola faz com os papéis que não têm mais utilidade?<br />E com as latas de alimentos e o plástico das garrafas PET e dos copos de água?<br /><br />
                                    Jogar no lixo comum é o procedimento mais corriqueiro, porém está longe de ser o adequado.<br /><br />
                                    Implantar a coleta seletiva traz benefícios para o meio ambiente - já que os materiais não terão a natureza como destino final - e para a própria comunidade, que frequentará ambientes mais limpos e agradáveis.<br /><br />

                                    Contudo, não basta espalhar lixeiras coloridas nos corredores para colocar em prática o programa. <br />
                                    É preciso um planejamento cuidadoso e, principalmente, um trabalho em equipe para garantir que seus objetivos - <b>conscientizar os alunos e educá-los</b> em um dos muitos aspectos relacionados ao cuidado com o meio ambiente - sejam atingidos.<br /><br />
                                    A iniciativa envolve várias etapas, desde a investigação sobre o impacto do descarte inadequado até a divulgação das pesquisas realizadas pelos alunos e dos resultados do projeto, que podem ser trabalhados em diversas disciplinas.<br />
                                    </p>
                                    <blockquote>
                                        "O processo deve ser complementado com outras ações de cidadania, ecologia e higiene para estimular a consciência ambiental de todos.
                                    </blockquote><br /><br />
                                    <hr />

                                    <h4>Redução do uso de papeis</h4>
                                    <b>Use a tecnologia</b>                                  
                                    <p>Exitem softwares como o <a @click="goToInclassLink" style="text-decoration:underline">InClass</a> que ajudam a manter os documentos de alunos atualizados e digitalizados. Professores deixam de usar diários em creches e lançam as informações diretamente no aplicativo, anotam as presenças em sala de aula por meio do notebook, tablet ou smartphone, só isso, já é uma economia de milhares de papeis por ano.<br /><br />

                                        Já os pais conseguem ter um controle via internet da vida escolar dos seus filhos. No lugar de enviar comunicados impressos, tudo fica registrado na plataforma. Os avisos chegam por mensagens, reduzindo drasticamente a quantidade de papel.
                                    </p>
                                    <blockquote>
                                        "Após a implantação do InClass passamos a não utilizar mais diários de papel e comunicados impressos para os pais, diz diretora da creche paulistana.
                                    </blockquote><br /><br />
                                    <hr />

                                    <h4>Atividades a céu aberto</h4>
                                    <p>
                                        <b>Brincar na natureza estimula a criatividade:</b><br />
                                        Os brinquedos são criados e reinventados a partir de recursos encontrados durante a brincadeira: <br />
                                        O galho que vira espada, a folha que vira um barquinho… Estudos com crianças escolarizadas mostram que nas áreas verdes da escola as crianças brincam de forma mais criativa e cooperativa. (Health Education Research,  2008).
                                        <br /><br />    
                                        Escolas que oferecem oportunidades de aprendizado fora da sala de aula, há uma melhora significativa no aproveitamento dos alunos em diferentes áreas do conhecimento.<br /><br />
                                        O acesso à natureza aumenta o equilíbrio e a autorregulação em jovens que vivem na cidade.<br /><br /><br />
                                    </p>
                                    <hr />

                                    <h4>Cultivo de plantas</h4>
                                    <p>
                                        <b style="color: black">Confira abaixo alguns benefícios que a construção afetiva com a natureza pode proporcionar:</b><br /><br />

                                        <b>Apresenta a origem dos alimentos</b><br />
                                        Saber o que está sendo consumido, quais são os nutrientes necessários para o crescimento e de onde vêm os alimentos é fundamental para as crianças, que estão iniciando a formação dos seus hábitos. Ao colocarem a mão na terra e plantarem frutas e verduras na escola, os alunos se familiarizam com os alimentos, compreendem do que eles são feitos e como podem contribuir para uma alimentação adequada.<br /><br />

                                        <b>Equilibra o uso de eletrônicos e o contato com a natureza</b><br />
                                        O primeiro contato com a natureza é capaz de abrir portas para despertar a curiosidade do aluno sobre o assunto, fazendo com que ele tenha um estímulo a mais para participar de atividades ao ar livre em vez de ficar o dia todo conectado aos aparelhos eletrônicos.<br /><br />

                                        <b>Promove o desenvolvimento motor</b><br />
                                        Ajudar a plantar as sementes das verduras ou a regar as plantas na horta são atividades físicas que ajudam no desenvolvimento motor infantil, de maneira a otimizar a movimentação e o equilíbrio. Além disso, participar da horta contribui com o melhoramento do desenvolvimento cognitivo e sensório-olfativo, uma vez que os alunos recebem novos conhecimentos sobre a natureza, tocando, visualizando e comendo aquilo que plantam.<br /><br />

                                        <b>Possibilita a aprendizagem na prática</b><br />
                                        A horta na escola pode servir de base para o aprendizado das disciplinas e dos seus conteúdos. Na aula de ciências, por exemplo, os alunos podem acompanhar de perto como se dá o nascimento e o crescimento das plantas. Já nos ensinamentos de matemática, o professor pode trabalhar economia doméstica por meio do uso dos alimentos plantados. O cultivo de uma horta cria situações de aprendizagem reais e diversificadas.<br /><br />

                                        <b>Incentiva a cuidar da natureza</b><br />
                                        Um dos maiores ganhos proporcionados pela horta na escola infantil é incentivar os pequenos a amar e cuidar da natureza. O fato de plantar, zelar pelas plantas enquanto estão crescendo e depois colher e comer o fruto ensina os alunos que, quando cuidamos do meio ambiente com carinho, ele pode nos retribuir positivamente.

                                    </p><br /><br /><br />
                                    <hr />

                                    <h4>Evitar uso de descartaveis de plástico</h4>
                                    <p>
                                        Em seis meses de campanha, os alunos do segundo e do terceiro anos do ensino fundamental do Colégio Pio XII, no Morumbi, SP, deixaram de usar 27 mil copos descartáveis para contribuir com ações de preservação meio ambiente. A ação recebeu homenagem da Organização das Nações Unidas (ONU).<br /><br />

                                        A coordenadora do ensino fundamental da escola, Rosimeire Vicente, acredita que a educação sobre a preservação do meio ambiente deve começar desde cedo.<br />
                                    </p>
                                    <blockquote>
                                        “É um processo que começa dentro do espaço escolar, onde o diálogo para essa situação surge”, disse a coordenadora.
                                    </blockquote> 
                                    <p>
                                        Além de tirar os copos plásticos dos bebedouros, a escola quer reduzir o uso de canudos de plástico e também banir o uso de plástico descartável nos eventos.<br />
                                    </p><br />
                                    


                                    <br /><br />
                                    <a style="cursor:pointer" @click="goToInclass"><img src="https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/banners%2Fbanner-fb01.jpg?alt=media" style="width:100%; height:auto"></a>
                                    <br /><br />
                                    
                                </div>
                                <div class="row" style="display:none">
                                    <!--start comments section-->
                                    <div class="col-sm-12">
                                        <h3 class="blog-details-subtitle">Comentários</h3>
                                        <ul class="blog-comments">
                                            <li>
                                                <img src="img/t2.jpg" alt="">
                                                <div class="blog-comment-author">
                                                    <h6>Lillie J. Yates</h6>
                                                    <a href="#" class="active"> Reply </a>
                                                    <span>Dec 26, 2017 at 15:35</span>
                                                    <p>Continually leverage existing distinctive sources after excellent data. Interactively evolve enterprise leadership skills vis-a-vis.</p>
                                                </div>
                                            </li>
                                            <li class="reply">
                                                <img src="img/t3.jpg" alt="">
                                                <div class="blog-comment-author">
                                                    <h6>Todd B. Tucker</h6>
                                                    <a href="#"> Reply </a>
                                                    <span>Jan 16, 2018 at 04:35</span>
                                                    <p>Professionally envisioneer enabled interfaces vis-a-vis plug-and-play supply chains. Competently benchmark real-time value without process-centric.</p>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <!--end comments section-->

                                    <!--start comment form-->
                                    <form class="col-sm-12 comment-form send-message">
                                        <h3 class="blog-details-subtitle">Leave a Reply</h3>
                                        <div class="row">
                                            <!--Name-->
                                            <div class="col-md-6">
                                                <input class="comment-input-field" type="text" placeholder="Name">
                                            </div>
                                            <!--Email-->
                                            <div class="col-md-6">
                                                <input class="comment-input-field" type="text" placeholder="Email">
                                            </div>
                                            <!--Message-->
                                            <div class="col-md-12">
                                                <textarea name="comment-message" placeholder="Message" rows="5"></textarea>
                                            </div>
                                        </div>
                                        <input class="btn softo-solid-btn" type="submit" value="Send">

                                    </form>
                                    <!--end comment form-->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--end blog single section-->

        <!--start footer section-->
        <!--start footer section-->
        <footer class="footer-section bg-secondary ptb-60">
            <div class="footer-wrap">
                <div class="container">
                    <div class="row">
                        <div class="col-md-6 col-md-offset-3">
                            <div class="footer-single-col text-center">
                                <img src="@/assets/site/img/logo-color.png" alt="footer logo" style="display:none">
                                <div class="footer-social-list">
                                    <ul class="list-inline">
                                        <li><a href="https://www.facebook.com/app.inclass" target="_blank"> <i class="fa fa-facebook"></i></a></li>
                                        <!-- <li><a href="#"> <i class="fa fa-twitter"></i></a></li> -->
                                        <li><a href="#"> <i class="fa fa-linkedin"></i></a></li>
                                        <!-- <li><a href="#"> <i class="fa fa-google-plus"></i></a></li> -->
                                        <li><a href="https://www.youtube.com/channel/UCpS1fZ6eIGeKLK3VUlnYibw" target="_blank"> <i class="fa fa-youtube"></i></a></li>
                                    </ul>
                                </div>
                                <div class="copyright-text">
                                    <p>&copy; copyright <a href="#">InClass</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        <!--end footer section-->

    </div><!--end main content inner-->
            
</div>
<!--end main container -->        
</template>



<!-- custom script -->
<!--script src="../../assets/site/js/scripts.js" defer></script-->

<script>
import Vue from 'vue';

import db from '@/components/firebaseInit';
import firebase,{ storage } from 'firebase';

import VueMeta from 'vue-meta';
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

import vueSmoothScroll from 'vue2-smooth-scroll'
Vue.use(vueSmoothScroll)

export default {
    name: 'cadsite',
    metaInfo: {
      title: 'Blog InClass',
    //   meta: [
    //     { charset: 'utf-8' },
    //     { name: 'viewport', content: 'width=device-width, initial-scale=1' }
    //   ]
//         meta: [
//         //    { name: 'description', content: 'Qual é a melhor idade para aprender inglês?' },
//         //    { name: 'og:url', content: 'https://www.inclass.app' },
//         //    { name: 'og:title', content: 'Blog InClass' },
//         //    { name: 'og:image', content: 'https://i.catracalivre.com.br/Za23hBkAFSCnzjBMa_-LXSe8ukM=/https%3A%2F%2Fcatracalivre.com.br%2Fwp-content%2Fuploads%2F2019%2F01%2Fistock-599956378.jpg' }




// // OpenGraph data (Most widely used)
//     {property: 'og:title', content: 'My Page Title ← My Site'},
//     {property: 'og:site_name', content: 'My Site'},
//     // The list of types is available here: http://ogp.me/#types
//     {property: 'og:type', content: 'website'},
//     // Should the the same as your canonical link, see below.
//     {property: 'og:url', content: 'https://inclass.app/blog/idade-para-aprender-ingles'},
//     {property: 'og:image', content: 'https://i.catracalivre.com.br/Za23hBkAFSCnzjBMa_-LXSe8ukM=/https%3A%2F%2Fcatracalivre.com.br%2Fwp-content%2Fuploads%2F2019%2F01%2Fistock-599956378.jpg'},
//     // Often the same as your meta description, but not always.
//     {property: 'og:description', content: 'I have things here on my site.'},

//     // Twitter card
//     {name: 'twitter:card', content: 'summary'},
//     {name: 'twitter:site', content: 'https://inclass.app/blog/idade-para-aprender-ingles'},
//     {name: 'twitter:title', content: 'My Page Title ← My Site'},
//     {name: 'twitter:description', content: 'I have things here on my site.'},
//     // Your twitter handle, if you have one.
//     {name: 'twitter:creator', content: '@alligatorio'},
//     {name: 'twitter:image:src', content: 'https://i.catracalivre.com.br/Za23hBkAFSCnzjBMa_-LXSe8ukM=/https%3A%2F%2Fcatracalivre.com.br%2Fwp-content%2Fuploads%2F2019%2F01%2Fistock-599956378.jpg'},

//     // Google / Schema.org markup:
//     {itemprop: 'name', content: 'My Page Title ← My Site'},
//     {itemprop: 'description', content: 'I have things here on my site.'},
//     {itemprop: 'image', content: 'https://i.catracalivre.com.br/Za23hBkAFSCnzjBMa_-LXSe8ukM=/https%3A%2F%2Fcatracalivre.com.br%2Fwp-content%2Fuploads%2F2019%2F01%2Fistock-599956378.jpg'}









//            //$('head').append('<meta property="og:type" content="profile"/>'); 
//             //$('head').append('<meta property="og:url" content=""/>');
//             //$('head').append("<meta property='og:title' content="+text+"'/>");
//             //$('head').append("<meta property='og:image' content="+imageUrl+"'/>");
//         ]
    },
    data() {
        return {
            nome: '',
            telefone: '',
            email: '',
            celular: '',
            escola: '',
            mensagem: ''
        };
    },
    methods: {
        enviarFormularioContato(){
            // timestamp
                var now = new Date();
                var year = "" + now.getFullYear();
                var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
                var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
                var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
                var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
                var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
                //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
                var customtimestamp = year + month + day + hour + minute + second
                db.collection('contato').add({
                    customtimestamp: customtimestamp,
                    nome: day,
                    mes: month,
                    ano: year,
                    nome: this.nome,
                    email: this.email,
                    celular: this.celular
                    
                })
                .then(docRef => {
                    console.log('Document written with ID: ', docRef.id);
                    alert("Formulário enviado com sucesso. Entraremos em contato em breve!")
                    
                })
                .catch(function (error) {
                    console.log('Error adding document: ', error);
                    alert("Ops! Tivemos um probleminha ao enviar os dados do formulário. Por favor, tente novamente!")
                })
        },
        goToInclass(){
            // Google Analytics - Events
            gtag('event', 'clicou', {
                'event_category': '/blog/sustentabilidade-creches-escolas',
                'event_label': 'banner'//,
                //'value': '<value>'
            });

            window.location.href = "/";
        },
        goToInclassLink(){
            // Google Analytics - Events
            gtag('event', 'clicou', {
                'event_category': '/blog/sustentabilidade-creches-escolas',
                'event_label': 'link'//,
                //'value': '<value>'
            });

            window.location.href = "/";
        }
    },
    created() {
    }
}





$(document).ready(function(){
    

    // ### Clique para download do app
    let deferredPrompt;

    window.addEventListener('beforeinstallprompt', function(event) {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      event.preventDefault();
      // Stash the event so it can be triggered later.
      deferredPrompt = event;
    });

    // ### INICIO - para o IOS - Download
    $("#bntAddFnIOS, #bntAddFnIOS2").click(function(){
        $(".custom-modal-ios").show();
        // alert("a");
        // // Detecta se o dispositivo está no iOS
        // const isIos = () => {
        //     const userAgent = window.navigator.userAgent.toLowerCase();
        //     return /iphone|ipad|ipod/.test( userAgent );
        // }
        // // Detects if device is in standalone mode
        // const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);
        // // Verifica se deve exibir notificação popup de instalação:
        // if (isIos() && !isInStandaloneMode()) {
        //     this.setState({ showInstallMessage: true });
        // }
    })
    // ### FIM - para o IOS

    // Installation must be done by a user gesture! Here, the button click
    var btnAdd = document.getElementById("bntAddFn");
    btnAdd.addEventListener('click', (e) => {
      // hide our user interface that shows our A2HS button
      //btnAdd.style.display = 'none';
      // Show the prompt
      deferredPrompt.prompt();
      // Wait for the user to respond to the prompt
      deferredPrompt.userChoice
        .then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            console.log('User accepted the A2HS prompt');
          } else {
            console.log('User dismissed the A2HS prompt');
          }
          deferredPrompt = null;
        });
    });

    // Installation must be done by a user gesture! Here, the button click
    var btnAdd = document.getElementById("download-app-button");
    btnAdd.addEventListener('click', (e) => {
      // hide our user interface that shows our A2HS button
      //btnAdd.style.display = 'none';
      // Show the prompt
      deferredPrompt.prompt();
      // Wait for the user to respond to the prompt
      deferredPrompt.userChoice
        .then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            console.log('User accepted the A2HS prompt');
          } else {
            console.log('User dismissed the A2HS prompt');
          }
          deferredPrompt = null;
        });
    });

    // Installation must be done by a user gesture! Here, the button click
    var btnAdd = document.getElementById("download-app-button-win");
    btnAdd.addEventListener('click', (e) => {
      // hide our user interface that shows our A2HS button
      //btnAdd.style.display = 'none';
      // Show the prompt
      deferredPrompt.prompt();
      // Wait for the user to respond to the prompt
      deferredPrompt.userChoice
        .then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            console.log('User accepted the A2HS prompt');
          } else {
            console.log('User dismissed the A2HS prompt');
          }
          deferredPrompt = null;
        });
    });


    $(".softo-btn-outline").click(function(){
        window.location.href = "#contact";
    })




    $(".navbar-toggle.collapsed").click(function(){
        if ($('#myNavbar').is(":visible"))
        {
            $("#myNavbar").slideUp('fast');
        }
        else{
            $("#myNavbar").slideDown('fast');
        }
        
    })

    $(".product-counter-section.ptb-40, #features, .promo-section.bg-secondary.ptb-90, #pricing, .testimonial-section.bg-secondary.ptb-90, #faqs").click(function(){
        $("#myNavbar").slideUp('fast');
    })

    $("#accordion .panel-heading").click(function(){
        if ($(this).parent().find(".collapse").is(":visible"))
        {
            $(this).parent().find("div.collapse").slideUp();
            $(this).find("h4 a").addClass("collapsed")
            $(this).find("h4 a").removeClass("collapse")
        }
        else{
            $(this).parent().find("div.collapse").slideDown();
            $(this).find("h4 a").removeClass("collapsed")
            $(this).find("h4 a").addClass("collapse")
        }
        
    })

    $("#myNavbar a").click(function(){
        $("#myNavbar").slideUp('fast');
    })

    $(".video").click(function(){
        $(".custom-modal").fadeIn("fast");
        $(".custom-modal-ios").hide();
    })

    $(".shadow, .fechar, .content").click(function(){
        $('.video-youtube').each(function(){
            var el_src = $(this).attr("src");
            $(this).attr("src",el_src);
        });
        $(".custom-modal").fadeOut("fast");
    })


    $("a").click(function(){
        gtag('event', 'clicou', {
            'event_category': '/site',
            'event_label': $(this).text()//,
            // 'value': '<value>'
        });
    })

    


// Pixel do Facebook
!function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', '139700983684961');
  fbq('track', 'PageView');

  // Evento do facebook - visualizaçao de conteudo    
  fbq('track', 'ViewContent');
})



</script>
<style>
    .hidden-sm-and-down, .hidden-sm-and-down a{
        display: none !important;
    }

    .breadcrumb-section{
        padding-top: 90px !important;
    }

    #myNavbar ul{
        position: relative;
        top: -19px;
    }

    h4{
        color: orange
    }

    b{
        color: #5a1e82;
    }

    .menu-acesso-rapido{
        display: none;
    }

</style>